import React from 'react'
import "./css/common.css"


export default function VisualizationsTab(props) {
        return (
                <div className="main_tab scrollbar_property">
                        VISUALIZATIONS
                        <br></br>
                        {props.selected_dataset}
                </div>
        )
}
